import "./header.scss";
import type { FC } from "react";
import { useMediaQuery } from "@onshopfront/components";
import { Navigation } from "./Navigation";
import NavigationMobile from "./NavigationMobile";

export const Header: FC = () => {
    const mobile = useMediaQuery("(max-width: 768px)");

    return (
        <header>
            {mobile ? (
                <NavigationMobile />
            ) : (
                <Navigation />
            )}
        </header>
    );
};
